import { render } from "./SldCommonEmpty.vue?vue&type=template&id=06ec06b7"
import script from "./SldCommonEmpty.vue?vue&type=script&lang=js"
export * from "./SldCommonEmpty.vue?vue&type=script&lang=js"
script.render = render

export default script